import { ILogger } from '@tdp/common/telemetry';

import { IAzureAdAppWriter } from './abstractions';
import { AzureAdAppSchema } from './models';

export interface TdpAzureAdAppServiceDeps {
  apiFetch: typeof fetch;
  logger: ILogger;
}
export class TdpAzureAdAppService implements IAzureAdAppWriter {
  private readonly apiFetch: typeof fetch;

  constructor(deps: TdpAzureAdAppServiceDeps) {
    this.apiFetch = deps.apiFetch;
  }

  async createAzureAdApp(displayName: string) {
    const response = await this.apiFetch('/aadapp/v2', {
      method: 'Post',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        displayName,
        signInAudience: 'AzureADMultipleOrgs'
      }),
    });
    if (response.status < 200 || response.status >= 300) {
      throw new Error(
        'TODO(nibeauli): replace this with a semantically useful domain object response'
      );
    }
    const maybeApp = (await response.json()) as unknown;
    //TODO(nibeauli): this should be safe parse and returning a domain object if parsing failed.
    const app = AzureAdAppSchema.parse(maybeApp);
    return app;
  }
}
